import { TextField, Box } from "@mui/material";

export default function SearchBar({ searchTerm, setSearchTerm }) {
  return (
    <Box sx={{ marginBottom: 3 }}>
      <TextField
        label="Search companies..."
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </Box>
  );
}
